module.exports = __webpack_public_path__ + "img/app4.cc850123.png";